<div>
	<span>{{"frame.footer.copyright" | msgKey}} </span>
	@if (releasnoteVersion()) {
		<span> | Version: {{ releasnoteVersion() }}</span>
	}
</div>
